import {
  MANOS_SUPPORT_EMAIL,
  MANOS_LEGAL_ENTITY,
  MANOS_COMPANY_NUMBER,
  MANOS_REGISTERED_OFFICE,
} from "../../config/branding";

export default function Privacy() {
  return (
    <div className="mx-auto max-w-3xl px-6 py-16 space-y-8">
      <h1 className="text-3xl font-bold tracking-tight">Privacy Policy</h1>
      <p className="text-sm text-muted-foreground">Last updated: 8 May 2026</p>

      <div className="prose prose-stone dark:prose-invert max-w-none space-y-6 text-sm leading-relaxed text-muted-foreground">
        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">Who we are</h2>
          <p>
            Manos is operated by {MANOS_LEGAL_ENTITY} (registered in England and Wales,
            company number {MANOS_COMPANY_NUMBER}). Our registered office is{" "}
            {MANOS_REGISTERED_OFFICE}. We are the data controller for the personal
            information described in this policy.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">What we collect</h2>
          <p>When you create an account, we collect your email address and name. When you use Manos, we store the data you enter: clients, jobs, invoices, photos, and notes. This data belongs to you.</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">How we use it</h2>
          <p>We use your data to provide the Manos service — managing your jobs, sending invoices, and generating reports. We do not sell your data to third parties. We do not use your data for advertising.</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">Data storage</h2>
          <p>Your data is stored securely on Gadget.dev's infrastructure, which uses industry-standard encryption at rest and in transit. Backups are taken automatically.</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">Cookies</h2>
          <p>We use a single session cookie to keep you signed in. We do not use tracking cookies, analytics cookies, or advertising cookies.</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">Your rights</h2>
          <p>You can export all your data at any time via the Reports page. You can delete your account via our <a href="/contact?topic=privacy" className="text-amber-600 hover:underline">contact form</a>. We will delete all your data within 30 days of your request.</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">Contact</h2>
          <p>
            Questions about privacy or wish to exercise your rights under UK GDPR?
            Send us a message via our <a href="/contact?topic=privacy" className="text-amber-600 hover:underline">contact form</a>{" "}
            or write to {MANOS_LEGAL_ENTITY}, {MANOS_REGISTERED_OFFICE}.
          </p>
        </section>
      </div>
    </div>
  );
}
